import { render, staticRenderFns } from "./activitiesManageList.vue?vue&type=template&id=352c864c&scoped=true"
import script from "./activitiesManageList.vue?vue&type=script&lang=js"
export * from "./activitiesManageList.vue?vue&type=script&lang=js"
import style0 from "./activitiesManageList.vue?vue&type=style&index=0&id=352c864c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352c864c",
  null
  
)

export default component.exports